import React, { useCallback, useContext, useRef, MouseEvent, LegacyRef } from 'react';
import { AccordionContext, useAccordionToggle } from 'react-bootstrap';
import classNames from 'classnames';
import { ChevronUp } from 'react-bootstrap-icons';
import { useDispatch } from 'react-redux';
import { toggledPropertyCategory } from '../../../Store/Filter/action';

interface Props {
    name: string,
}

export const CategoryToggle: React.FC<Props> = ({ name }) => {
    const dispatch = useDispatch();
    const currentEventKey = useContext(AccordionContext);
    const decoratedOnClick = useAccordionToggle(name);
    const categoryElementRef: LegacyRef<HTMLParagraphElement> | null = useRef(null);

    const toggleCategory = useCallback((event: MouseEvent<HTMLElement>) => {
        dispatch(toggledPropertyCategory(name));
        decoratedOnClick(event);
    }, [name, decoratedOnClick]);

    const toggleCategoryByKeyDown = useCallback(() => {
        if (!categoryElementRef?.current) {
            return;
        }

        categoryElementRef.current.click();
    }, [categoryElementRef]);

    return (
        <p
            className={classNames('category', currentEventKey === name ? 'open' : 'closed')}
            onClick={toggleCategory}
            onKeyDown={toggleCategoryByKeyDown}
            ref={categoryElementRef}
        >
            <ChevronUp />
            {name}
        </p>
    );
}
